import React, {
    useCallback, useState, useEffect
} from 'react';
import PropTypes from 'prop-types';

import { ModalNext, ModalHeader, ModalBody, ModalFooter } from '@jutro/components';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

import { Button } from '@jutro/legacy/components';
import metadata from './AddressValidationComponent.metadata.json5';

function AddressValidationComponent(props) {
    const {
        size,
        addresses,
        isOpen,
        onResolve,
        onReject,

    } = props;



    const renderSelectColumn = (item, index) => {
        return (
            <Button className="btn-link" onClick={() => onResolve(item)}>Select</Button>
        );
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: 'left',
            showRequired: true,
        },
        addressValidationTable: {
            data: addresses.geocodingAddresses,
        },
    };
    const resolvers = {
        resolveCallbackMap: {
            renderSelectColumn
        },
        resolveComponentMap: {},
    };


    return (
        <ModalNext isOpen={isOpen} className={size}>
            <ModalBody id="addressValidation">
                <ViewModelForm
                    uiProps={metadata.componentContent}
                    overrideProps={overrideProps}
                    model={{}}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </ModalBody>
            <ModalFooter >
                <Button onClick={onReject}>Save & Close </Button>
            </ModalFooter>
            

        </ModalNext>
    );
}

AddressValidationComponent.propTypes = {
    size: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onReject: PropTypes.func.isRequired,
    onResolve: PropTypes.func.isRequired
};
AddressValidationComponent.defaultProps = {
    // title: 'Recommend Address',
    size: 'lg'
};

export default AddressValidationComponent;
